import React, { useEffect, useRef, useState } from "react";
import { getRemotedbUrl } from "../../../lib/ep";

const Reprocessing = ({ ticket_id, promotion_id, finished }) => {
	const processing = useRef(-1);
	const [counter, setCounter] = useState(0);

	const check_status = (promotion_id, ticket, cb) => {
		fetch(getRemotedbUrl(`/stages/prereq_reprocess_status/${promotion_id}/${ticket}`)).then((r) => r.json()).then((r) => {
			if(r.status == 1) {
				processing.current = -1;
				cb(r);
			}

			if(r.status == 2) {
				processing.current = -1;
				cb(r);
			}

			if(r.status == 4) {
				processing.current = -1;
				cb(r)
			}
		});

		setTimeout(() => {
			if(processing.current == -1) return;
			processing.current++;
			if(processing.current > 50) {
				cb({ status:9 });
				return;
			}

			setCounter(processing.current);
			check_status(promotion_id, ticket, cb);
		}, 2000);
	};

	useEffect(() => {
		processing.current = 0;
		check_status(promotion_id, ticket_id, finished);
	}, [ ticket_id ]);

	return (
		<>Reprocessing... {counter}</>
	);
};

export default Reprocessing;